import { ref } from 'vue';
import { defineStore } from 'pinia';

export const usePaymentsStore = defineStore('payments', () => {
  const fromDate = ref<string | undefined>(undefined);
  const toDate = ref<string | undefined>(undefined);

  return { fromDate, toDate };
}, { persist: true });
